module.exports = __webpack_public_path__ + "static/media/bru.c61e8d06.svg";